import { getStructureDefaultValue } from "@client/settings/structure";
import { type Form } from "../types";

import definitions from "./definitions.json";
import structure from "./structure.json";

export const DEFAULT_VALUE: Form.EndingSettings = getStructureDefaultValue(
  "form-ending",
  structure,
  definitions
) as Form.EndingSettings;
